const PasswordRenderer = ({ value }) => {
  return (
    value || '*********'
  );
};

export default PasswordRenderer;
